import type { ComponentProps } from 'react';
import type React from 'react';

import { Image, ThemeProvider } from '@change/ds-core-ui';

import type { QrCodeType } from '@change-corgi/middle-end-gql-schema';

import { usePetitionQRCode } from '#src/app/shared/hooks/qrcode';

// An SVG with a white background which scales to 100% width and height.
// Using a transparent, or white, 1x1 pixel PNG did not work in Firefox; the alt text was shown.
const WHITE_SVG =
	"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='100%25' height='100%25' fill='white'/%3E%3C/svg%3E";

export const PetitionQRCode: React.FC<
	{
		slugOrId: string;
		size: number;
		type: QrCodeType;
	} & ComponentProps<typeof Image> & { ref?: React.RefObject<HTMLImageElement> }
> = ({ slugOrId, size, type, ref, ...rest }) => {
	const { data } = usePetitionQRCode({
		slugOrId,
		size,
		type,
		adjustForPixelRatio: true,
	});

	return (
		<ThemeProvider>
			<Image
				src={data?.imageBase64Uri || WHITE_SVG}
				width={size}
				height={size}
				alt="Petition QR Code"
				aspectRatio="1:1"
				style={{ minWidth: `${size}px`, minHeight: `${size}px` }}
				{...rest}
				ref={ref}
			/>
		</ThemeProvider>
	);
};
